import { studentNotificationsRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";
import { createRoute } from "@/routes/utils";
import { IRoleEnum } from "@/interfaces";

const permission = [IRoleEnum.Student];

const studentNotificationsRouteMetadata: IRouteMetadataObj<
  typeof studentNotificationsRoutesObj
> = {
  list: {
    title: "studentNotifications.index.title",
    description: "studentNotifications.index.description",
    lazy: () => import("@/pages/studentPages/notification/table/page"),
    mode: "index",
    type: "main",
    icon: "BookLine",
    breadcrumbs: [],
    permission,
  },
};

export const studentNotificationsRoutes = createRoute<
  typeof studentNotificationsRoutesObj
>(studentNotificationsRoutesObj, studentNotificationsRouteMetadata);
